
import XButton from 'vux/src/components/x-button/index.vue'

import { mapState, mapActions, mapMutations } from 'vuex'
import { phoneRegex } from '@/tools/regex'

export default {
components: {
XButton
},
data () {
return {
code: '',
leftTime: 60,
isSendCode: false,
phone: '',
checkCellPhone: function (e) {
return {
valid: phoneRegex.test(e),
msg: '請填寫正確手機號碼'
}
}
}
},
computed: {
...mapState({
userInfo: state => state.user.userInfo
})
},
methods: {
...mapActions({
getLoginUserInfo: 'getLoginUserInfo'
}),
...mapMutations({
setAccountRisk: 'setAccountRisk'
}),
sendCodeToPhone () {
if (!this.userInfo.cellphone && !this.phone) {
return this.$vux.toast.text('請輸入手機號碼', 'bottom')
}

if (this.isSendCode) {
return this.$vux.toast.text('驗證碼已發送請核驗', 'bottom')
}

this.$store.dispatch('sendCodeVerifyCellPhone', {
cellphone: this.userInfo.cellphone || this.phone,
cb: (data) => {
if (!data || data.error) {
this.$vux.toast.text(data.error, 'bottom')
return
}
this.isSendCode = true
this.$refs.ipt.focus()
this.$vux.toast.text('驗證碼已發送至手機', 'bottom')
const timer = setInterval(() => {
--this.leftTime
if (this.leftTime === 0) {
clearInterval(timer)
this.isSendCode = false
this.leftTime = 120
}
}, 1000)
}
})
},
handleSubmit () {
if (!this.code) {
return this.$vux.toast.text('請填寫驗證碼', 'bottom')
}

this.$vux.loading.show({
text: '送出中...'
})

this.$store.dispatch('confirmVerifyCellPhone', {
cellphone: this.userInfo.cellphone || this.phone,
token: this.code,
cb: (data) => {
this.$vux.loading.hide()
if (!data || data.error) {
console.log('手机验证失败', data.error)
this.$vux.toast.text('手機驗證失敗')
} else {
this.getLoginUserInfo({refresh: true})
this.setAccountRisk(false)
this.$router.replace('/')
this.$vux.toast.text('已完成手機驗證')
}
}
})
},
onPhoneChange (value) {
this.phone = value
}
}
}
